/**
 * Import classes
 */
import ConfirmLeave from '../../modules/form/confirmLeave';

/**
 * Make instances
 */
const confirmLeave = new ConfirmLeave();

/**
 * Execute functions
 */
confirmLeave.onClickClose();
confirmLeave.onClickConfirm();
confirmLeave.onClickModalClose();
